{
  "404": {
    "description": "Lo siento, no encontramos la página que estabas buscando. ¿Quizás escribiste mal la URL? Revisa la URL ingresada.",
    "go_to_home": "Volver al inicio",
    "ops_nothing_to_see_here": "Ops, no hay nada que ver aquí.",
    "title": "404 Página no encontrada"
  },
  "actors": {
    "actor_view": {
      "actor_updated_successfully": "Interveniente actualizado con éxito!",
      "page_title": "Interveniente",
      "sections": { "company_data": "Datos de la Empresa", "notification_groups": "Grupos de Notificación" }
    },
    "actors_list": {
      "actor_deleted": "Interveniente eliminado con éxito",
      "add_new_actor": "Agregar interveniente",
      "page_title": "Intervenientes"
    },
    "new_actor": { "page_title": "Cadastrar Interveniente", "success": "Interveniente agregado con éxito" }
  },
  "agents": {
    "all_agents": "Todos Agentes",
    "btn_create": "Crear Agente",
    "create_success": "Agente ha sido creado con éxito",
    "executions": {
      "cards": { "total": "Total de Execuções", "errors": "Errores", "today": "hoy" },
      "new": "Nuevo Agente",
      "page_title": "Ejecuciones de Agentes",
      "status": { "failed": "Errore", "all": "Todos" },
      "table": { "duration": "Duración", "entity_type": "Tipo de Entidade", "scheduled": "Programada" },
      "tabs": { "production": "Producción", "test_runs": "Ejecución de Testes" },
      "test_run": "Testar Ejecución",
      "detail": {
        "action": "Acción",
        "callback_curl": "O dispara el callback tú mismo — tu servicio debería hacer un POST con algo equivalente a esto.",
        "callback_url": "URL de Callback (aquí se POSTea el resultado)",
        "dispatch": { "waiting_callback": "Aguardando callback" },
        "entity_data": "Datos de la entidad",
        "insights_successful": "{{count}} insights insertados/actualizados",
        "orders_successful": "{{count}} pedidos insertados/actualizados",
        "output": "Salida",
        "processes_successful": "{{count}} procesos insertados/actualizados",
        "processes_tracked_successful": "{{count}} procesos actualizados",
        "processing": "Procesando",
        "started_at": "Iniciado en",
        "step_not_started": "Este paso aún no ha sido ejecutado.",
        "steps": "Pasos",
        "trigger": "Disparador",
        "triggered_at": "Disparado en",
        "webhook_response": "Respuesta de webhook",
        "manual_curl": {
          "label": "cURL Manual — ejecuta esto en tu máquina",
          "description": "La ejecución espera un callback. Pega el cURL de abajo en tu terminal — ya incluye la URL del procesador configurada en el agente. Puedes cambiarla para llamar a otro endpoint, inclusive local. Tu servicio corre y hace POST al callback URL de abajo — no se necesita túnel."
        },
        "status": {
          "failed": "fallido",
          "pending": "pendiente",
          "running": "ejecutando",
          "skipped": "omitido",
          "success": "éxito"
        }
      },
      "dev_mode_modal": {
        "dispatch_hint": "A Flowls envía un POST con el input a la URL configurada del agente.",
        "execute_actions_hint": "Las acciones se ejecutan como en producción — se realizarán escrituras en la base de datos.",
        "execute_actions": "Ejecutar acciones",
        "invalid_json": "JSON inválido. Corrige el JSON para ejecutar la prueba.",
        "manual_curl_hint": "No se realiza un POST de salida. Flowls genera un cURL que ejecutas localmente — no se necesita túnel.",
        "run_test": "Ejecutar prueba",
        "select_lpco_input": "Seleccionar una Lpco",
        "select_order_input": "Seleccionar un Pedido",
        "select_process_input": "Seleccionar un Proceso",
        "skip_actions_hint": "Validar la forma del callback pero NO escribir en la base de datos.",
        "skip_actions": "Ignorar acciones (por defecto)",
        "title": "Componer ejecución de prueba",
        "input_label": "Input"
      }
    },
    "form": {
      "step_name": {
        "subtitle": "Dale a este agente un nombre claro para facilitar su identificación.",
        "title": "Nombra tu agente"
      },
      "step_trigger": {
        "subtitle": "Define qué inicia este agente.",
        "title": "Elige un Disparador",
        "descriptions": {
          "event_trigger": "Disparar cuando ocurra un evento específico en un registro",
          "received_mail": "Disparar cuando llegue un correo a la bandeja de entrada",
          "received_teams_message": "Disparar desde un canal o DM en Teams",
          "recurring_schedule": "Ejecutar en un intervalo fijo (diario, semanal, etc.)",
          "webhook": "Recibir un POST de un sistema externo"
        },
        "event_trigger_form": {
          "entity": "Entidad",
          "entity_subtitle": "Selecciona el tipo de registro a monitorizar."
        },
        "recurring_schedule_form": {
          "frequency_periods": { "DAYS": "días", "HOURS": "horas", "WEEKS": "semanas" },
          "frequency": "Frecuencia",
          "recurring_schedule": "Ejecutar cada"
        },
        "webhook": {
          "info": "La URL y la clave API para el webhook entrante se generarán después de que se cree el agente."
        }
      },
      "step_configure_input": {
        "subtitle": "Define de dónde provienen los datos para este agente.",
        "title": "Configura la Entrada",
        "descriptions": {
          "external_api": "Llamar a una API REST para obtener datos",
          "google_drive": "Leer datos de una hoja de cálculo de Google Sheets",
          "no_input": "Ejecutar el agente sin ningún input",
          "operations": "Selecciona operaciones, entidad y filtros",
          "sharepoint": "Obtener datos de una lista de SharePoint"
        },
        "operations_form": {
          "filters": "Procesar solo los registros que cumplen estas condiciones.",
          "operation_description": "Selecciona qué operaciones ejecuta esta programación."
        }
      },
      "step_processor": {
        "configure_title": "Configurar: {{ processor }}",
        "subtitle": "Selecciona el paso lógico que analiza o transforma la entrada.",
        "title": "Elige un Procesador",
        "form": {
          "custom_webhook": {
            "auth_type": "Autenticación",
            "credential": "Credencial de autenticación",
            "disclaimer": "Este procesador envía la carga útil del agente a su punto final, que puede transformar los datos antes de que se ejecuten las acciones seleccionadas.",
            "expected_keys": "Claves esperadas en la respuesta: `orders`, `processes`.",
            "headers": { "key": "Llave", "value": "Valor" }
          }
        }
      },
      "step_actions": {
        "default": "Por defecto",
        "disclaimer": "Las acciones se ejecutarán en secuencia automáticamente.",
        "subtitle": "Una acción predeterminada se incluye automáticamente. Puedes agregar más de forma opcional.",
        "title": "Acciones",
        "descriptions": {
          "post_in_teams": "Publicar un mensaje en un canal de Microsoft Teams",
          "send_email": "Enviar un correo a un destinatario o función responsable",
          "set_insights": "Guardar los hallazgos de inconsistencias",
          "update_tracking": "Actualizar los datos de tracking de los procesos a partir de los datos recibidos",
          "upload_document": "Crear un documento para una entidad específica",
          "upsert_orders": "Crear o actualizar pedidos a partir de los datos recibidos",
          "upsert_processes": "Crear o actualizar procesos a partir de los datos recibidos",
          "upsert_products": "Crear o actualizar productos a partir de los datos recibidos"
        },
        "infos": {
          "update_tracking": "Esta acción consume <b>processes</b>.",
          "upsert_orders": "Esta acción consume <b>orders</b>.",
          "upsert_processes": "Esta acción consume <b>processes</b>.",
          "upsert_products": "Esta acción consume <b>products</b>."
        }
      }
    },
    "list": { "page_title": "Agentes Configurados", "new": "Nuevo Agente" }
  },
  "attendance_phase": { "subsidiary": { "title": "Transportador" } },
  "audit_checklist": {
    "approve_audit": "¿Aprobar Auditoría?",
    "do_you_want_to_audit_order": "¿Desea aprobar auditoría?",
    "title": "Cheklist"
  },
  "automations": {
    "creation": {
      "fields_for_categories": {
        "1": { "args": { "1": { "title": "Cuando pasar" } } },
        "2": { "args": { "1": { "title": "Cuando pasar" }, "2": { "title": "Sin confirmación de" } } },
        "3": { "args": { "1": { "title": "Cuando se falta" } } },
        "4": { "args": { "1": { "title": "Cuando se falta" }, "2": { "title": "Sin confirmación de" } } },
        "5": { "args": { "1": { "title": "Cuando llegar" } } },
        "6": { "args": { "1": { "title": "Cuando llegar" }, "2": { "title": "Sin confirmación de" } } },
        "7": { "args": { "1": { "title": "Cuando" }, "2": { "title": "es más tarde que" }, "3": { "title": "en" } } }
      },
      "form": {
        "date_field": { "in": "de" },
        "field": "Campo",
        "filters": "Para condiciones:",
        "quantity": "Cant",
        "success": "Automatización ha sido creada con éxito!",
        "webhook": "Informe URL"
      },
      "templates": { "label": "Modelo de fecha" },
      "title": "Crear automatización"
    },
    "delete": { "success": "Automatización eliminada con éxito!", "title": "Eliminar {{title}}?" },
    "list": {
      "descriptions": {
        "AFTER_DATE": "Cuando pasar <b>{{amount}}</b> <b>{{type}}</b> de <b>{{date}}</b>",
        "AFTER_DATE_WITH_FIELD": "Cuando pasar <b>{{amount}}</b> <b>{{type}}</b> de <b>{{date}}</b> sin confirmación de <b>{{confirmation}}</b>",
        "BEFORE_DATE": "Cuando se falta <b>{{amount}}</b> <b>{{type}}</b> para <b>{{date}}</b>",
        "BEFORE_DATE_WITH_FIELD": "Cuando se falta <b>{{amount}}</b> <b>{{type}}</b> para <b>{{date}}</b> sin confirmación de <b>{{confirmation}}</b>",
        "ON_DATE": "Cuando llegar<b>{{date}}</b>",
        "ON_DATE_WITH_FIELD": "Cuando llegar <b>{{date}}</b> sin confirmación de <b>{{confirmation}}</b>",
        "ON_DATE_GREATER_THAN": "Cuando <b>{{date}}</b> es más tarde que <b>{{dateTarget}}</b> en <b>{{amount}}</b> <b>{{type}}</b>"
      },
      "periods": {
        "DAYS": "días",
        "DAYS_one": "día",
        "HOURS": "horas",
        "HOURS_one": "hora",
        "MINUTES": "minutos",
        "MINUTES_one": "minuto",
        "MONTHS": "meses",
        "MONTHS_one": "mes"
      },
      "title_one": "{{count}} automatización en <b>{{operationName}}</b>",
      "title_other": "{{count}} automatizaciones en <b>{{operationName}}</b>"
    },
    "periods": { "DAYS": "Días", "HOURS": "Horas", "MINUTES": "Minutos", "MONTHS": "Meses" },
    "status": { "off": "OFF", "on": "ON" },
    "templates": {
      "AFTER_DATE": "Cuando pasar <b>un período</b> de <b>una fecha</b>",
      "AFTER_DATE_WITH_FIELD": "Cuando pasar<b>um período</b> de <b>una fecha</b> sin <b>confirmación de um campo</b>",
      "BEFORE_DATE": "Cuando faltar <b>un período</b> para <b>una fecha</b>",
      "BEFORE_DATE_WITH_FIELD": "Cuando se falta <b>un período</b> para <b>una fecha</b> sin <b>confirmación de un campo</b>",
      "ON_DATE": "Cuando llegar<b>una fecha</b>",
      "ON_DATE_WITH_FIELD": "Cuando llegar <b>una fecha</b> sin<b>confirmación de un campo</b>",
      "ON_DATE_GREATER_THAN": "Cuando <b>una fecha</b> es más tarde que <b>otra fecha</b> en <b>un período</b>"
    }
  },
  "booking_quotations": {
    "detail": {
      "back": "Volver a cotizaciones",
      "canceled_at": "Cancelada el",
      "closed_at": "Cerrada el",
      "closes_at": "Cierra el",
      "draft_empty": "La cotización aún no ha sido enviada. El envío se hace desde el proceso.",
      "history": "Historial",
      "history_empty": "Ningún evento registrado.",
      "history_events": {
        "CLOSED": "Cotización cerrada automáticamente",
        "FREIGHT_FORWARDER_DECLINED": "{{agent}} declinó",
        "PROPOSAL_SUBMITTED": "{{agent}} envió una propuesta",
        "PROPOSAL_WITHDRAWN": "{{agent}} canceló la propuesta",
        "SENT_one": "Cotización enviada a {{count}} agente",
        "SENT_other": "Cotización enviada a {{count}} agentes",
        "declined_one": "{{count}} declinó",
        "declined_other": "{{count}} declinaron",
        "responded_one": "{{count}} de {{total}} respondió",
        "responded_other": "{{count}} de {{total}} respondieron"
      },
      "not_found": "Cotización no encontrada.",
      "opened_at": "Abierta el",
      "order": "Pedido {{code}}",
      "received_proposals": "Propuestas recibidas",
      "route": "Carga → Descarga",
      "summary": "Resumen",
      "total_freight": "Flete total",
      "transit_days_one": "{{count}} día de tránsito",
      "transit_days_other": "{{count}} días de tránsito"
    },
    "list": {
      "columns": {
        "identification": "Identificación",
        "operation_route": "Operación / Ruta",
        "period": "Período",
        "proposals": "Propuestas",
        "status": "Situación"
      },
      "order": "pedido {{code}}",
      "page_title": "Cotizaciones",
      "period": { "closed": "cerrada", "no_return": "sin respuesta", "to_close": "p/ cerrar" },
      "proposals": {
        "none": "Ninguna propuesta recibida",
        "responded": "{{responded}} de {{invited}} respondidas",
        "sealed": "valores en reserva"
      },
      "search_placeholder": "Buscar cotización…",
      "sort": { "closes_at": "Cierre", "inserted_at": "Registro", "published_at": "Envío" },
      "status": { "today": "hoy {{time}}" },
      "title": "Cotizaciones",
      "view_action": "Ver cotización"
    }
  },
  "buttons": {
    "add": "Agregar",
    "active": "Activar",
    "archive": "Archivar",
    "back": "Volver",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "clear_all": "Borrar todos",
    "confirm": "Confirmar",
    "delete": "Eliminar",
    "download": "Descargar",
    "edit": "Editar",
    "filters": "Filtros",
    "process_filters": "Filtros",
    "lead_time_filters": "Lead Time",
    "go_to_home": "Volver al inicio",
    "hide": "Ocultar",
    "hide_all": "Ocultar todo",
    "inactive": "Desactivar",
    "keep_editing": "Continuar Editando",
    "not_save": "No guardar",
    "register": "Registrar",
    "remove": "Eliminar",
    "save": "Guardar",
    "save_changes": "Guardar alteraciones",
    "show": "Mostrar",
    "show_all": "Mostrar todo",
    "undo_cancel": "Deshacer cancelación",
    "undo_delete": "Deshacer eliminación",
    "view": "Ver",
    "yes_delete": "Sí, eliminar"
  },
  "common": {
    "cellphone": "Teléfono",
    "copied": "Copiado",
    "copy": "Copiar",
    "hours": "Horas",
    "plate": "Placa",
    "type": "Tipo"
  },
  "datagrid": {
    "actionsCellMore": "más",
    "checkboxSelectionHeaderName": "Seleccionar casilla",
    "columnHeaderFiltersLabel": "Mostrar filtros",
    "columnHeaderSortIconLabel": "Ordenar",
    "columnMenuFilter": "Filtros",
    "columnMenuHideColumn": "Ocultar",
    "columnMenuLabel": "Menú",
    "columnMenuManageColumns": "Administrar Columnas",
    "columnMenuShowColumns": "Mostrar columnas",
    "columnMenuSortAsc": "Ordenar ascendente",
    "columnMenuSortDesc": "Ordenar descendente",
    "columnMenuUnsort": "No ordenar",
    "sortByTitle": "Ordenar por",
    "sortDirectionTitle": "Sentido",
    "sortDirectionDesc": "Descendente",
    "sortDirectionAsc": "Ascendente",
    "dateFilterTitle": "Filtrar por fecha",
    "dateFilterStart": "Inicio",
    "dateFilterEnd": "Fin",
    "dateFilterClear": "Limpiar período",
    "columnsManagementSearchTitle": "Encontar columna",
    "columnsManagementShowHideAllText": "Mostrar/Ocultar todo",
    "columnsManagementNoColumns": "No columnas",
    "columnsManagementReset": "Resetear",
    "filterOperatorAfter": "después de",
    "filterOperatorBefore": "antes de",
    "filterOperatorContains": "Contiene",
    "filterOperatorEndsWith": "termina com",
    "filterOperatorEquals": "es igual a",
    "filterOperatorIs": "es",
    "filterOperatorIsAnyOf": "es cualquiera de",
    "filterOperatorIsEmpty": "está vacío",
    "filterOperatorIsNotEmpty": "no está vacío",
    "filterOperatorNot": "no es",
    "filterOperatorNotContains": "no contiene",
    "filterOperatorNotEquals": "diferente",
    "filterOperatorIsNoneOf": "no es cualquiera de",
    "filterOperatorOnOrAfter": "en o después de",
    "filterOperatorOnOrBefore": "en o antes de",
    "filterOperatorStartsWith": "comienza con",
    "filterPanelAddFilter": "agregar filtro",
    "filterPanelColumns": "Columnas",
    "filterPanelDeleteIconLabel": "Eliminar",
    "filterPanelInputLabel": "Valor",
    "filterPanelInputPlaceholder": "Filtrar Valor",
    "filterPanelOperator": "Operadores",
    "filterPanelOperatorAnd": "E",
    "filterPanelOperatorOr": "O",
    "filterPanelRemoveAll": "Borrar Filtros",
    "filterValueAny": "Cualquier",
    "filterValueFalse": "No",
    "filterValueTrue": "Sí",
    "footerRowSelectedMore": "{{count}} líneas seleccionadas",
    "footerRowSelectedOne": "1 línea seleccionada",
    "footerTotalRows": "Total",
    "footerTotalVisibleRows": "{{visibleCount}} de {{totalCount}}",
    "labelDisplayedRows": "{{from}} - {{to}} de {{count}}",
    "labelDisplayedRowsUnknown": "{{from}} - {{to}}",
    "labelRowsPerPage": "Líneas por página",
    "noResultsOverlayLabel": "Sin resultados encontrados",
    "noRowsLabel": "Sin resultado",
    "pinToLeft": "Fijar a la izquierda",
    "pinToRight": "Fijar a la derecha",
    "toolbarColumns": "Columnas",
    "toolbarColumnsLabel": "Selccionar columnas",
    "toolbarDensity": "Densidad",
    "toolbarDensityComfortable": "Cómodo",
    "toolbarDensityCompact": "Compacto",
    "toolbarDensityStandard": "Estándar",
    "toolbarExport": "Exportar",
    "toolbarExportCSV": "Descargar CSV",
    "toolbarFilters": "Filtros",
    "toolbarFiltersLabel": "Ver Filtros",
    "toolbarFiltersTooltipActiveMore": "{{count}} filtros activos",
    "toolbarFiltersTooltipActiveOne": "1 filtro activo",
    "toolbarFiltersTooltipHide": "Ocultar Filtros",
    "unpin": "Desanclar"
  },
  "datepickers": {
    "range_shortcuts": {
      "this_week": "Esta Semana",
      "last_week": "Última Semana",
      "last_7_days": "Últimos 7 Días",
      "last_30_days": "Últimos 30 Días",
      "current_month": "Mes Actual",
      "last_month": "Mes Passado",
      "reset": "Resetear"
    }
  },
  "drivers": {
    "drivers_list": {
      "add_new_driver": "Agregar conductor",
      "driver_deleted": "Motorista eliminado con éxito!",
      "page_title": "Conductores",
      "title": "Conductores"
    },
    "drivers_new": {
      "page_title": "Registrar Conductor",
      "success": "Conductor agregado con éxito",
      "title": "Registrar Conductor"
    },
    "edit_driver": {
      "page_title": "Editar Conductor",
      "success": "Conductor actualizado con éxito",
      "title": "Editar Conductor"
    }
  },
  "entities_report": {
    "actor": "Intervenientes",
    "driver": "Conductores",
    "mercante": "Mercante",
    "product": "Productos",
    "route": "Rutas",
    "trailer": "Remolques",
    "vehicle": "Vehículos"
  },
  "errors": { "something_went_wrong": "¡Algo salió mal!" },
  "external_invite": {
    "attachments": {
      "count_one": "{{count}} archivo",
      "count_other": "{{count}} archivos",
      "dropzone_title_one": "Arrastre el archivo o haga clic para enviar",
      "dropzone_title_other": "Arrastre archivos o haga clic para adjuntar",
      "file_invalid_type": "{{name}}: tipo de archivo no aceptado",
      "file_too_large": "{{name}}: supera los 10 MB",
      "optional": "— opcional",
      "select_files_one": "Seleccionar archivo",
      "select_files_other": "Seleccionar archivos"
    },
    "booking_data": {
      "booking_number": "Número de booking",
      "closed_description": "El ATD fue registrado y esta página es de solo lectura.",
      "confirm_description": "Revisa los datos antes de enviar. El envío actualiza el proceso y reemplaza los valores actuales.",
      "copy_to": "Se enviará un resumen a {{email}}.",
      "document": "Documento del booking (PDF)",
      "document_caption": "Solo PDF, hasta 10 MB",
      "editable_until_atd": "Puedes corregir y reenviar hasta el ATD.",
      "eta_before_etd": "El ETA no puede ser anterior al ETD.",
      "form_hint": "Informa el número, el documento y la ruta confirmados con la naviera.",
      "load_error": "No fue posible cargar los datos del embarque. Recargue la página.",
      "review": "Revisar",
      "send": "Enviar booking",
      "sent": "Booking enviado.",
      "winner_proposal": "propuesta ganadora {{number}}. Completa los datos del booking a continuación."
    },
    "booking_quotation": {
      "all_proposals": "Todas las propuestas enviadas",
      "closed_description": "Cerrada el {{date}}. Estas son las propuestas enviadas.",
      "completed_description": "El agente ganador fue seleccionado. Gracias por participar.",
      "confirm_edit_description": "Revisa los cambios antes de guardar. La propuesta puede editarse hasta el cierre.",
      "confirm_send_description": "Revisa el resumen antes de enviar. La propuesta puede editarse hasta el cierre.",
      "copy_to": "Se enviará una copia a {{email}}.",
      "days_one": "{{count}} día",
      "days_other": "{{count}} días",
      "decline": "No voy a participar",
      "decline_confirm": "Declinar participación",
      "decline_confirm_description": "Dejarás de participar en esta cotización y no podrás enviar propuestas. Si lo deseas, cuéntale el motivo al embarcador.",
      "decline_confirm_title": "No voy a participar",
      "decline_reason_hint": "Las observaciones solo son visibles para el embarcador.",
      "decline_reason_label": "Motivo (opcional)",
      "declined_description": "Informaste que no participarás en esta cotización. Agradecemos tu respuesta.",
      "declined_title": "Participación declinada",
      "dropzone_caption": "PDF, XLSX, DOCX o imagen · hasta 10 MB cada uno · varios archivos",
      "edit": "Editar propuesta {{sequence}}",
      "editable_until_close": "Edición disponible hasta el cierre.",
      "editing": "En edición",
      "empty_proposals": "Usted no envió propuestas para esta cotización.",
      "international": "Internacional",
      "international_transport": "Transporte internacional",
      "load_error": "No fue posible cargar la cotización. Recargue la página.",
      "new_proposal": "Nueva propuesta",
      "proposals_sent_one": "{{count}} propuesta enviada",
      "proposals_sent_other": "{{count}} propuestas enviadas",
      "review": "Revisar",
      "send": "Enviar propuesta",
      "sent": "Propuesta enviada.",
      "sent_at": "Valores en dólares estadounidenses (USD). Enviada el {{date}} — editable hasta el cierre.",
      "subtotal": "subtotal",
      "table_summary": "Resumen",
      "total_hint": "suma de los tres bloques, calculada automáticamente",
      "updated": "Propuesta actualizada.",
      "values_hint": "Valores en dólares estadounidenses (USD). Edición disponible hasta el cierre.",
      "withdraw": "Retirar propuesta {{sequence}}",
      "withdraw_confirm_description": "La propuesta dejará de valer para esta cotización y no podrá reenviarse.",
      "withdraw_confirm_title": "¿Retirar la propuesta {{sequence}}?",
      "withdrawn": "Propuesta retirada.",
      "your_proposal": "Su propuesta"
    },
    "canceled": {
      "description": "Esta cotización fue cancelada por el embarcador el <strong style=\"white-space:nowrap\">{{date}}</strong>. No es posible enviar ni editar la propuesta.",
      "description_BOOKING_DATA": "Esta solicitud de booking fue cancelada por el embarcador el <strong style=\"white-space:nowrap\">{{date}}</strong>. No es posible enviar los datos del booking.",
      "tip": "Las propuestas enviadas fueron archivadas. En caso de duda, contacte al responsable de la operación.",
      "tip_BOOKING_DATA": "En caso de duda, contacte al responsable de la operación.",
      "title": "Invitación cancelada",
      "title_BOOKING_DATA": "Solicitud de booking cancelada",
      "title_BOOKING_QUOTATION": "Cotización cancelada"
    },
    "expired": {
      "description": "El período de esta cotización finalizó el <strong style=\"white-space:nowrap\">{{date}}</strong>. No es posible enviar ni editar la propuesta.",
      "tip": "Para participar en una nueva ronda, solicite un enlace actualizado al responsable de la operación.",
      "title": "Enlace vencido"
    },
    "not_found": {
      "description": "No encontramos una invitación para este enlace. Verifique que la dirección se haya copiado correctamente.",
      "title": "Enlace inválido"
    },
    "otp_form": {
      "code_expiry_hint": "El código vence en 10 minutos",
      "description": "Enviamos un código de 6 dígitos a {{email}}. Ingrese el código para abrir el formulario de propuesta.",
      "resend_cooldown": "Reenviar código en {{time}}",
      "resend_link": "¿No lo recibió? Reenviar código",
      "security_notice": "Acceso por enlace único, sin necesidad de registrarse en Flowls. El enlace y el código son válidos solo para esta invitación.",
      "submit": "Acceder al formulario",
      "title": "Confirme su acceso",
      "try_again": "Intentar de nuevo"
    }
  },
  "extra_fields": { "boolean": { "empty": "Vacio", "false": "No", "true": "Sí" } },
  "file_uploads": {
    "accepted_extensions": "Extensiones aceptadas: {{ extensions }}",
    "saved_files": "Archivos guardados",
    "upload_file": "Compartir archivo"
  },
  "first_letters": { "days": "d", "hours": "h" },
  "flowls_ai": {
    "beta_warning": "🚧 Esta funcionalidad está en fase Beta. Por favor, verifique la información proporcionada.",
    "error_message": "Hubo un problema para enviar su mensaje. Intente nuevamente más tarde.",
    "greetings": "¡Hola! Soy Flowlzito, la Inteligencia Artificial de Flowls. ¿Cómo puedo ayudar?",
    "input_placeholder": "Haga una pregunta",
    "loading": "Estoy pensando",
    "new_conversation": "Iniciar una nueva conversación"
  },
  "fields": { "duimp": { "advance_delivery": "Entrega Anticipada" } },
  "foreign_trade": {
    "documents_widgets": {
      "automatic_link_tooltip": "Vinculado automáticamente",
      "label": {
        "ANVISA": "ANVISA",
        "BLUE": "Canal Azul",
        "GRAY": "Canal Gris",
        "GREEN": "Canal Verde",
        "INMETRO": "INMETRO",
        "MAPA": "MAPA",
        "ORANGE": "Canal Naranja",
        "RED": "Canal Rojo",
        "YELLOW": "Canal Amarillo"
      }
    },
    "invoice_widgets": {
      "brazilian": {
        "drawer": {
          "access_key": "Clave de acceso",
          "sections": { "dates": { "emitted_at": "Fecha de emisión", "title": "Fechas" } },
          "title": "Nota fiscal nº / Factura Invoice nº",
          "types": { "0": "Entrada", "1": "Salida" }
        }
      },
      "empty_widget": "Este proceso aún no tiene facturas registradas.\r\n",
      "products": { "import_products": "Importar Productos" }
    },
    "palletization": {
      "title": "Paletizado",
      "read_only": "Solo lectura",
      "add_pallets": "Agregar Pallets",
      "empty": "Ningún tamaño informado",
      "size": "Tamaño del pallet",
      "quantity": "Cant.",
      "height_cm": "Altura (cm)",
      "not_informed": "No informar el tamaño",
      "iso_group": "Estándar ISO 6780",
      "custom_option": "Personalizado…",
      "custom": "Personalizado",
      "total": "Total de pallets",
      "empty_description": "Informe cuántos pallets de cada tamaño se embarcarán.",
      "size_placeholder": "Seleccione el tamaño…",
      "not_informed_group": "Sin detalle",
      "not_informed_option_hint": "solo la cantidad total",
      "not_informed_hint": "Solo la cantidad total — sin detallar por tamaño.",
      "custom_option_hint": "informar L × A",
      "custom_title": "Tamaño personalizado",
      "length": "Largo",
      "width": "Ancho",
      "errors": {
        "row_invalid": "Informe el tamaño y una cantidad mayor que cero, o elimine la fila.",
        "height_invalid": "La altura debe ser mayor que cero.",
        "dimension_invalid": "Debe ser mayor que cero"
      }
    },
    "road_transport": {
      "empty_road_transport": "Este proceso aún no tiene transportes terrestres registrados.",
      "fields": { "DTA": "DTA", "no_DTA": "Sin DTA" },
      "transport": {
        "container": "Contenedor {{number}}",
        "empty_transport_list": "Este proceso aún no tiene transportes registrados.",
        "route_required_to_add_trips": "Seleccione una ruta para habilitar los viajes."
      }
    },
    "shared_widgets": {
      "alert_status": {
        "invalid": "Clave de seguimiento inválida.",
        "not_found": "Datos no encontrados. Verifique el número ingresado.",
        "pending": "Esperando Datos"
      },
      "authorization_status_alert": {
        "forbidden": "El usuario no tiene permiso para accender el recurso solicitado, verifique las credenciales",
        "not_authorized": "Credenciales inválidas. Asegúrese de haber proporcionado las credenciales de seguridad correctas."
      },
      "ce_mercante_alert": "Debido a las limitaciones de la API de origen, no es posible identificar los eventos que ocurrieron antes del inicio del seguimiento.",
      "cleared_duimp_alert": "Debido a las limitaciones de la API de Siscomex, todavía no es posible obtener datos de despacho de aduana cuando se introduce una DUIMP (Declaración Única de Importación) después del despacho de aduana.",
      "insertedAtLabel": "Insertado en {{date}}",
      "updatedAtLabel": "Actualizado en {{date}}"
    },
    "tracking_widgets": {
      "air": {
        "drawer": {
          "account": "Cuenta",
          "arrival_at": "Fecha de llegada efectiva",
          "arrival_datetime": "Fecha/hora de llegada",
          "arrival_unit_rfb": "Unidad de la RFB de llegada",
          "basic_info": "Información básica",
          "cargo_items": "Ítems de la carga",
          "collect": "Collect",
          "consignee": "Consignatario",
          "currency": "Moneda de origen",
          "customs_of_arrival": "Recinto aduanero de llegada",
          "customs_of_departure": "Recinto aduanero de salida",
          "customs_of_destination": "Recinto aduanero de destino",
          "departure_at": "Fecha de salida efectiva",
          "departure_datetime": "Fecha/hora de salida",
          "departure_unit_rfb": "Unidad de la RFB de salida",
          "domestic_departure": "Salida nacional",
          "estimated_arrival_at": "Fecha de llegada prevista",
          "estimated_departure_at": "Fecha de salida prevista",
          "file_cargo_responsible": "Responsable del archivo del conocimiento de carga",
          "flight_code": "Código de vuelo",
          "inlet_term": "Término de entrada",
          "international_departure": "Salida internacional",
          "item_description": "Descripción de la mercancía",
          "item_freight_price": "Flete por ítem de carga (sumatoria)",
          "item_gross_weight": "Peso bruto (kg)",
          "item_quantity_of_volumes": "Cantidad de bultos",
          "land_arrivals": "Llegadas por vía terrestre",
          "mawb": "MAWB",
          "prepaid": "Prepaid",
          "receive_cargo": "Presencia de carga",
          "ruc_number": "Número de RUC",
          "shipper": "Embarcador",
          "term": "Término",
          "title": "Carga aérea",
          "trips": "Viajes",
          "uf": "UF"
        }
      },
      "ce_mercante": {
        "drawer": {
          "cargo_category": "Categoría de Carga",
          "consignee": "Consignatário",
          "cubage": "Cubicación (m³)",
          "freight": "Flete",
          "freight_component_currency": "Moneda",
          "freight_component_payment_type": "Recaudación",
          "freight_component_type": "Tipo",
          "freight_component_value": "Valor",
          "freight_components": "Componentes del Flete",
          "general_data": "Datos Generales del Conocimiento",
          "modality": "Modalidad",
          "type": "Tipo de Conocimineto"
        }
      },
      "maritime": {
        "containers": {
          "hide_unlinked": "No mostrar Contenedores Desvinculados",
          "link_container": "Vincular Contenedor al Proceso",
          "show_unlinked": "Mostrar Contenedores Desvinculados",
          "unlink_container": "Desvincular Contenedor del Proceso"
        },
        "labels": { "automatic": "Tracking Automático" },
        "international_transport_legs": { "title": "Legs" }
      }
    }
  },
  "form_sections": {
    "audit": { "approve_audit": { "audit_approved": "Consignatário", "title": "Aprobar Auditoría" } },
    "complete_registration": {
      "complete_btn": "Completar Registro",
      "country_input": "Elige su país",
      "description": "Este es su primer acceso a la plataforma, necesitamos confirmar algunos datos para completar su registro.",
      "success_completion": "👏🏼 🎉 ¡Todo listo, {{ name }}! ¡Ahora puedes comenzar a usar Flowls!\r\n",
      "terms_and_conditions": "Estoy de acuerdo con los Términos de Uso y la Política de Privacidad",
      "title": "¡Hola, bienvenid@ a Flowls!"
    },
    "document_uploads": { "empty_document_list": "Aún no hay documentos enviados" },
    "export_dates_form": { "title": "Fecha del Pedido" },
    "supplier_form": { "title": "Fecha del Pedido" },
    "widgets": {
      "drawer": {
        "content": {
          "advance_delivery": "Entrega Anticipada",
          "basic": "Información básica",
          "complement": "Información complementar",
          "boarding": "Embarque",
          "cargo": "Carga",
          "cargo_subfields": {
            "area": "Recinto",
            "arrival_date_time": "Fecha/hora de llegada",
            "cargo_identification": "Identificación de carga",
            "commercial_invoice": "Factura Comercial Vinculada",
            "customs_area": "Recinto Aduanero",
            "dispatch_units": "Unidades de despacho",
            "final_destination_unit_of_the_bill_of_lading": "Unidad de destino final del conocimiento de embarque",
            "gross_weight": "Peso Bruto (kg)",
            "inlet_outlet_unit": "Unidad de entrada/descarga",
            "net_weight": "Peso Neto (kg)",
            "origin_country": "País de Origen"
          },
          "clearance": "Despacho",
          "consents": "Autorizaciones",
          "consents_subfields": {
            "boarding_expiry_date": "Fecha Val. Embarque",
            "consenting_body": "Organismo Autorizante",
            "consenting_situation": "Situación de la Autorización",
            "dispatch_expiry_date": "Fecha Val. Despacho",
            "license_text": "Texto Autorizante"
          },
          "admin_controls_subfields": {
            "admin_control_body": "Órgano",
            "admin_control_situation": "Situación de la Conferencia de los Anuentes",
            "risk_analyses_result": "Resultado del Análisis de Riesgo",
            "situation_licensing": "Situación del Licenciamiento"
          },
          "customs_subfields": {
            "custom_body": "Órgano",
            "custom_situation": "Situación de la Conferencia Aduanera",
            "risk_analyses_result": "Resultado del Análisis de Riesgo"
          },
          "dates": "Fechas",
          "delivered": "Entrega",
          "due_events_table": {
            "action": "Evento",
            "date": "Fecha/Hora",
            "extra_info": "Información adicional",
            "responsible": "Responsable"
          },
          "exporter_subfields": { "ruc": "RUC" },
          "general": "Datos Generales",
          "general_subfields": {
            "delivery_status": "Estado de entrega",
            "protocol": "Protocolo",
            "retification": "Rectificación",
            "total_additions": "Total de Adiciones"
          },
          "importer": "Importador",
          "importer_subfields": {
            "address": "Dirección",
            "identifier": "CNPJ",
            "name": "Nombre",
            "rfb": "Unidad RFB de Despacho"
          },
          "national_registration": "CNPJ",
          "packages": "Embalajes",
          "packages_subfields": {
            "cargo_item": "Ítem Carga",
            "danger_class": "Clase de Peligro",
            "dangerous_goods": "Mercancía Peligrosa",
            "gross_weight": "Peso Bruto (kg)",
            "quantity": "Cantidad",
            "package_type": "Tipo de Embalaje",
            "type": "Tipo",
            "use_wooden_packaging": "Usar Embalaje de Madera",
            "wood_packaging_feature": "Característica del Embalaje de Madera"
          },
          "payments": "Pagos",
          "payments_subfields": {
            "fee_value": "Valor Multa",
            "payment_date": "Fecha de Pago",
            "total_value": "Valor Total",
            "type": "Tipo de Pago"
          },
          "register": "Registro",
          "situation": "Situación",
          "situation_subfields": {
            "admin_control": "Control Administrativo",
            "cargo_control": "Control de Carga",
            "customs_control": "Control Aduanero"
          }
        },
        "forms": {
          "comment_helper_text": "Este comentario se guardará cuando guarde los cambios realizados en este proceso."
        }
      }
    }
  },
  "global_tracking": {
    "no_content": "No se pudo cargar el mapa.",
    "title": "Tracking",
    "vessel_overlay": { "knots": "knots" },
    "vessels": {
      "card": { "last_updated_at": "Últ. Actualización: {{ date }}" },
      "empty_list": "No encontramos ningún resultado",
      "filters": {
        "search": "Buscar por {{ params }}",
        "search_params": {
          "air": "Avión, proceso",
          "maritime": "Barco, Contenedor, Proceso",
          "road": "Vehículo, Proceso",
          "train": "Tren, proceso",
          "warehouse": "Almacén, proceso"
        },
        "show_own_fleet": "Solo carga propia"
      }
    }
  },
  "importer_modal": {
    "caption": "Extensiones aceptadas: XLSX",
    "description": "Utilice nuestra funcionalidad de importación de datos para cargar grandes volúmenes de información de manera sencilla. Comience descargando la plantilla de la hoja de cálculo a través del botón de abajo. Esta plantilla ayuda a preparar sus datos en el formato correcto. Luego, solo arrastre y suelte la hoja de cálculo completa en el área indicada para importar sus datos de forma eficiente.",
    "download_template": "Descagar tamplate",
    "import_info": "Importar {{ title }}",
    "order_products": {
      "product_not_found": "No se pudo encontrar el producto de la línea {{ row }} con el código {{ code }"
    },
    "success": "Importación finalizada con éxito. Líneas importadas con éxito: {{ importedRows }}",
    "update": "Reemplazar archivo",
    "upload": "Agregar archivo"
  },
  "info": { "exporting": "📤 Exportando..." },
  "input_select": {
    "interaction_hint": "Escriba para buscar",
    "no_options_select": "Ninguna opción encontrada",
    "searching": "Realizando búsqueda",
    "not_found": "Datos no encontrados para"
  },
  "insight_indicator": {
    "tooltip_title_one": "{{count}} insight identificado",
    "tooltip_title_other": "{{count}} insights identificados"
  },
  "insights": {
    "title": "Insights",
    "group_by": {
      "none": "Todos",
      "category": "Por categoría",
      "analysis": "Por análisis",
      "rule": "Por regla",
      "entityType": "Por tipo de entidad",
      "entity": "Por entidad"
    },
    "filters": {
      "title": "Filtros",
      "clear": "Limpiar",
      "active_label": "Activos:",
      "sections": { "category": "Categoría", "analysis": "Análisis", "rule": "Regla", "entity_type": "Tipo de entidad" }
    },
    "toolbar": {
      "heading": "Insights",
      "meta_summary": "{{insightCount}} insights · {{categoryCount}} categorías · {{entityCount}} entidades",
      "meta_summary_no_entity": "{{insightCount}} insights · {{categoryCount}} categorías",
      "search_placeholder": "Buscar insight...",
      "entity_search_placeholder": "Buscar entidad...",
      "clear_all": "Limpiar",
      "expand_all": "Expandir todo",
      "collapse_all": "Contraer todo"
    },
    "common": { "all": "Todos", "expand": "Expandir", "collapse": "Recolher" },
    "dashboard": {
      "empty_state": "No hay insights con estos filtros.",
      "insights_in_section_one": "{{count}} insight",
      "insights_in_section_other": "{{count}} insights",
      "entity_type_unknown": "Desconocido"
    },
    "card": {
      "feedback_great": "¡Genial!",
      "feedback_relevant": "Relevante",
      "feedback_irrelevant": "No relevante",
      "evidences": "Evidencias",
      "evidence_null": "nulo",
      "date_first_seen": "Primer registro",
      "date_last_seen": "Último registro"
    },
    "lifecycle": {
      "acknowledged": "Resuelto",
      "dismissed": "No relevante",
      "acknowledge_tooltip": "Resuelto — tratado y concluido",
      "dismiss_tooltip": "Marcar como no relevante",
      "dismiss_feedback_title": "Feedback enviado",
      "dismiss_feedback_none": "Descartado sin un motivo"
    },
    "feedback": {
      "title": "¿Por qué no es relevante?",
      "subtitle": "Tu feedback entrena el modelo que genera los insights.",
      "comment_placeholder": "¿Qué hizo que este insight fuera incorrecto? (opcional)",
      "submit": "Enviar feedback",
      "skip": "Descartar sin motivo",
      "error": "No se pudo guardar tu feedback. Inténtalo de nuevo.",
      "reasons": {
        "false_positive": "Falso positivo — no es un problema real",
        "irrelevant": "Irrelevante para este proceso",
        "incorrect_info": "Información incorrecta o desactualizada",
        "duplicate": "Duplicado de otro insight"
      }
    },
    "run_audit": {
      "button": "Ejecutar auditoría",
      "cooldown_minutes": "{{minutes}} min",
      "cooldown_tooltip": "Última auditoría el {{lastRun}}. Podrás ejecutarla de nuevo en {{minutes}} min.",
      "cooldown_tooltip_no_last": "Podrás ejecutarla de nuevo en {{minutes}} min.",
      "running_title": "Auditoría en curso",
      "running_subtitle": "Analizando el proceso en busca de divergencias, inconsistencias y puntos de atención. Los insights aparecerán aquí al finalizar la ejecución.",
      "running_hint": "Puede tardar algunos minutos. Si prefieres, vuelve más tarde para ver el resultado.",
      "empty_title": "Ninguna auditoría ejecutada",
      "empty_subtitle": "Inicia una auditoría para identificar divergencias y puntos de atención en este proceso.",
      "error_title": "No se pudo cargar el estado de la auditoría",
      "error_subtitle": "Algo salió mal al cargar la auditoría de este proceso. Inténtalo de nuevo.",
      "retry": "Intentar de nuevo"
    }
  },
  "integrations": {
    "api_requests": {
      "filters": {
        "api_keys": "Origen",
        "status_code": { "error": "Error", "success": "Éxitos" },
        "title": "Filtrar por:"
      },
      "modal": { "title": "Solicitud" },
      "operations": { "today": "Hoy" }
    },
    "docs": {
      "api_key": "API Key",
      "no_content": "No hay documentación para mostrar.",
      "title": "Docs",
      "download_spec": "Download OpenAPI Spec"
    }
  },
  "json_viewer": {
    "clear_search": "Limpiar búsqueda",
    "collapse_all": "Colapsar todo",
    "copy_all": "Copiar todo",
    "expand_all": "Expandir todo",
    "items": "elementos",
    "keys": "claves"
  },
  "kanban": { "phase_column": { "order_by": "Ordenación" } },
  "language_switcher": { "en-US": "Inglés-US", "es-ES": "Español", "pt-BR": "Portugués-BR" },
  "costs": {
    "title": "Costos",
    "tabs": { "aggregated_header": { "processes": "Procesos" }, "process": { "title": "Embarques" } },
    "no_content": { "text": "Aún no hay información aquí." },
    "header": {
      "model_select_label": "Modelo",
      "reference_date_label": "Referencia Data",
      "date_range": { "start_date": "Início", "end_date": "Fim" }
    }
  },
  "lead_times": {
    "configure_lead_times_modal": {
      "create_lead_time_form": {
        "blocked_stages_section": "Para configurar las etapas de su modelo, seleccione qué operaciones incluirá este modelo",
        "example": "Ejemplo",
        "example_description": "Si el evento de referencia para su planificación es \"Entrega\", durante la creación del proceso deberá proporcionar una fecha planificada para la Entrega. Los demás eventos planificados se calcularán automáticamente en función de esta fecha.",
        "no_dates": "Aún no tienes fechas registradas.",
        "no_stages": "Aún no tiene tramos registrados.",
        "reference_event_description": "Defina el evento de referencia para la planificación del proceso:",
        "reference_for_planning": "Referencia para la planificación"
      },
      "update_lead_time_model": { "success_message": "Modelo de Lead Time actualizado con éxito!" },
      "footer": { "submit_button": "Crear modelo", "update_button": "Actualizar modelo" },
      "lead_time_model": {
        "cannot_delete_model": "No es posible eliminar un modelo de Lead Time mientras tenga Lead Times Planejados vinculados. Para ello, elimine los Lead Times Planejados manualmente.",
        "deleted_message": "Modelo de Lead Time excluído con éxito!",
        "planned_lead_time": {
          "deleted_message": "Lead Times planeado excluído con éxito!",
          "name": "Nombre de lo lead times planejado",
          "no_content": "Aún no tienes lead times planejados registrados."
        }
      },
      "models_list": { "title": "Modelos" },
      "no_models": "Aún no tiene modelos registrados.",
      "please_select_a_model": "Por favor, seleccione un modelo",
      "title": "Configurar Lead Times"
    },
    "header": {
      "no_lead_times_to_export": "No hay Lead Times para exportar",
      "date_range": { "start_date": "Início", "end_date": "Fim" }
    },
    "model_select": { "label": "Modelo" },
    "no_content": { "text": "Aún no hay información aquí." },
    "stages": { "at_least_one": "Complete al menos uno de los campos.", "days": "Días", "hours": "Horas" },
    "tabs": {
      "aggregated_header": {
        "deviation": "Desviación",
        "processes": "Procesos",
        "realized_or_estimated": "LT real/plan"
      },
      "lead_time": { "by_lead_time": "por_lead_time", "title": "Lead times" },
      "product": { "by_product": "por_producto", "title": "Producto" }
    },
    "title": "Lead times"
  },
  "location_management_modal": {
    "no_place_found": "Ningun local ha sido encontrado para el  interveniente seleccionado",
    "select": { "label": "Interveniente" },
    "select_local_to_view_map": "Seleccione una dirección para ver el mapa.",
    "select_place": "Seleccionar local"
  },
  "lpcos": {
    "drawer": {
      "attachments_documents_section": "Documentos",
      "attachments_dossiers_section": "Dossiers",
      "attachments_empty": "Ningún anexo vinculado a este LPCO.",
      "attachments_tab": "Anexos",
      "document_status_discarded": "Descartado",
      "document_status_read": "Leído",
      "document_status_unread": "No leído",
      "field_column": "Campo",
      "form_completion": {
        "boolean": "Booleano",
        "composite": "Compuesto",
        "date": "Fecha",
        "date_and_hour": "Fecha y hora",
        "dynamic_domain": "Dominio dinámico",
        "list": "Lista de valores",
        "number": "Número",
        "text": "Texto"
      },
      "general_data": "Datos Generales",
      "general_tab": "General",
      "generic_attribute": "Atributo",
      "guidance_title": "Orientación",
      "history_automatic": "Automático",
      "history_changed": "modificado",
      "history_request": "Solicitud",
      "import_indicator_direct": "Importación directa",
      "import_indicator_on_behalf": "Importación por cuenta y orden",
      "import_indicator_on_order": "Importación por encargo",
      "items_list": "Lista de Ítems",
      "model": "Modelo",
      "no_dictionary_definition": "Definición no disponible en el diccionario de atributos.",
      "not_catalogued": "No catalogado",
      "possible_values_title_one": "Valor posible ({{count}})",
      "possible_values_title_other": "Valores posibles ({{count}})",
      "required_attribute": "obligatorio",
      "show_less": "Ver menos",
      "show_more": "Ver más",
      "value_column": "Valor",
      "validity_expired_one": "Vencido hace {{count}} día",
      "validity_expired_other": "Vencido hace {{count}} días",
      "validity_remaining_one": "Válido por {{count}} día más",
      "validity_remaining_other": "Válido por {{count}} días más",
      "validity_title": "Vigencia"
    },
    "list": {
      "columns": {
        "agency": "Órgano",
        "identification": "Identificación",
        "insights": "Insights",
        "linked_declarations": "DUIMPs / DUEs",
        "model": "Modelo",
        "model_agency": "Modelo / Órgano",
        "status": "Situación",
        "validity": "Vigencia"
      },
      "expiry": {
        "days_one": "{{count}} día",
        "days_other": "{{count}} días",
        "expired": "Expirado",
        "months_days": "{{months}}m {{days}}d",
        "months_one": "{{count}} mes",
        "months_other": "{{count}} meses",
        "suffix": "p/ expirar",
        "today": "Hoy",
        "years_months": "{{years}}a {{months}}m",
        "years_one": "{{count}} año",
        "years_other": "{{count}} años"
      },
      "filters": { "insights": "Insights", "no_agency_options": "Ningún órgano disponible en esta página" },
      "not_linked": "No vinculada",
      "page_title": "LPCOs",
      "result_count_one": "{{count}} resultado",
      "result_count_other": "{{count}} resultados",
      "search_placeholder": "Buscar nº de LPCO…",
      "title": "LPCO",
      "view_action": "Ver LPCO"
    }
  },
  "maritime_transport": {
    "mercante": {
      "datagrid": { "end_date": "Fin (ETB)", "start_date": "Início (ETB)", "vessel_country": "Bandera del Buque" },
      "title": "Escalas Mercante"
    }
  },
  "modals": {
    "batch_update": {
      "automatic_tracking_alert": "Los procesos <strong>{{ referenceCodes }}</strong> tienen habilitado el Tracking automático. Al guardar, se deshabilitará para estos procesos.",
      "btn_label": "Actualizar",
      "components": {
        "field_select": "Campos",
        "preview_table": { "empty": "Sin datos modificados", "title": "Campos modificados" },
        "process_alert": "Por favor, seleccione al menos un proceso",
        "process_list_title": "Procesos a modificar"
      },
      "title": "Actualización en lote",
      "update_success": "Procesos actualizados con éxito"
    },
    "create_automation": { "title": "Crear automatización" },
    "create_order": { "create_btn": "Crear Pedido", "success": "¡Pedido creado con éxito!", "title": "Nuevo Pedido" },
    "create_process": {
      "add_to_process": "Agregar proceso",
      "alert_add_to_process_more": "Ha añadido {{ productsAdded }} productos al proceso",
      "alert_add_to_process_one": "Ha añadido 1 producto al proceso",
      "create_btn": "Crear Proceso",
      "error": {
        "missing_products_to_orders": "Para crear el proceso, adicione productos de todos los Pedidos",
        "order_ids": "Seleccione al menos un pedido",
        "product_items": "Añada al menos un producto a este proceso",
        "reference_code": "Complete el número de Proceso",
        "required_lead_time_datetime_reference": "Elija una fecha de referencia al lead times planificado",
        "shipment_modal_type": "Seleccione un modal de transporte"
      },
      "link_lead_time": { "form": { "datetime_reference": "[{{referenceEvent}}] planeado" } },
      "link_orders": { "label": "Pedido", "placeholder": "Seleccione los pedidos", "searching": "Buscando pedidos" },
      "orders": { "title": "Pedidos" },
      "process_content": { "title": "Lista de Productos" },
      "shipment_type": { "title": "Modal de Transporte" },
      "submit_process": "Crear Proceso",
      "success": "¡Proceso creado con éxito!",
      "table": { "order_total": "Total del pedido", "this_process": "En este proceso" },
      "title": "Nuevo Proceso"
    },
    "location_creation": {
      "address_search": "Buscar dirección",
      "new_address": "Nueva Dirección",
      "search_for_a_address_to_continue": "Busque una dirección para continuar",
      "success": "¡Ubicación registrada con éxito!",
      "title": "Crear Nueva Dirección",
      "waiting_address": "Esperando dirección"
    },
    "location_deletion": {
      "cannot_remove_address": "No es posible eliminar direcciones asignadas a una ruta",
      "description": "¿Está seguro de que desea eliminar esta dirección? Esta acción no se puede deshacer.",
      "success": "¡Dirección eliminada con éxito!",
      "title": "Eliminar Dirección"
    },
    "location_edit": { "success": "Dirección modificada con éxito!", "title": "Editar Dirección" },
    "order_creations": {
      "create": "Crear",
      "title": "Pedido de Transporte",
      "toast_messages": {
        "error_especific_handler": "Seleccione un {{handler}}",
        "error_reference_code": "Complete la referencia",
        "error_road_transport_order": "Complete los datos del pedido",
        "error_road_transport_order_type": "Complete el tipo de pedido",
        "route": "Seleccione una ruta",
        "success": "✅  Pedido generado con éxito!"
      }
    },
    "update_order": {
      "reset_changes_btn": "Descartar Cambios",
      "success": "Pedido actualizado con éxito!",
      "update_btn": "Actualizar Pedido"
    },
    "confirm_cost_close": {
      "title": "Cerrar Costo",
      "description_with_planned": "¿Está seguro de que desea cerrar este costo? Esta acción detendrá la propagación de los costos planificados e impedirá la actualización de los realizados.",
      "description": "¿Está seguro de que desea cerrar este costo? Esta acción impedirá la actualización de los costos realizados."
    },
    "confirm_update_process_cost_model_version": {
      "title": "Cambiar Versión del Modelo de Costos",
      "description": "¿Está seguro de que desea cambiar esta versión del modelo de costos? Esta acción eliminará los costos realizados de la versión actual."
    },
    "confirm_cost_reopen": { "title": "Reabrir Costo", "description": "¿Está seguro de que desea reabrir este costo?" }
  },
  "not_authorized": {
    "description": "Lo sentimos, no tiene acceso a este recurso.",
    "go_to_home": "Volver al inicio",
    "title": "No autorizado"
  },
  "operation_trash": {
    "modal": {
      "description": "Al hacer clic en confirmar, el elemento recuperado estará disponible para su visualización en la operación",
      "title": "¿Recuperar {{entity}} {{reference_code}}"
    },
    "tabs": { "orders": "Pedidos", "processes": "Procesos" },
    "title": "Papelera"
  },
  "container_components": { "create_form": { "sections": { "washing": "Lavado del Contenedor" } } },
  "operations": {
    "export_excel": "Exportar Plantilla",
    "exporting_data_sheet": "Exportar plantillas de datos...",
    "exporting_excel": "Exportando...",
    "exporting_excel_success": "Planilla exportada con éxito!",
    "exporting_excel_error": "Error al exportar planilla. Por favor, intente nuevamente más tarde.",
    "new_process": "Nuevo Proceso",
    "phases": { "FINISHED": "Finalizado" },
    "quick_filters": {
      "filter_options_column": {
        "empty_filtered_results_text": "No se encontraron resultados",
        "search_input_label": "Filtrar",
        "is_empty": "Está vacío",
        "is_not_empty": "No está vacío"
      },
      "title": "Filtros Rápidos"
    },
    "tabs": { "kanban": "Kanban", "lead_times": "Lead times", "table": "Tabla", "costs": "Costs" },
    "title": "Operaciones"
  },
  "operations_table": { "title": "Tabla" },
  "order_components": {
    "product_list_form": {
      "fields": { "sku": "SKU" },
      "product_divergence": {
        "alerts_column": "Alertas",
        "columns": { "field": "Campo", "order": "Pedido", "product": "Registro" },
        "fields": { "description": "Descripción", "mercosulCode": "NCM", "translatedDescriptions": "Traducciones" },
        "force_sync": "Forzar actualización",
        "force_sync_description": "Forzar la actualización reemplaza el NCM, la descripción y las traducciones del ítem del pedido por los datos vigentes del registro del producto. El cambio solo se aplica después de guardar el pedido.",
        "force_sync_success": "Ítem actualizado. Guarde el pedido para aplicar el cambio.",
        "pending_sync": "Cambio pendiente de guardar",
        "title": "Divergencia con el registro"
      },
      "sections": {
        "adjusted_lead_time": "Lead times - Ajustado",
        "administrative_treatment": "Tratamiento Administrativo",
        "customs": "Despacho",
        "default_lead_time": "Lead times - Estándar",
        "delivery": "Entrega",
        "item_status": "Estado del Ítem",
        "invoice": "Invoice",
        "note": "Observaciones",
        "order": "Pedido",
        "planning": "Planificación",
        "product": "Producto",
        "shipment": "Embarque",
        "stock": "Stock",
        "supplier": "Proveedor",
        "tax_treatment": "Tratamiento Tributario"
      }
    }
  },
  "order_modal": {
    "actions_menu": {
      "cancel_order_with_processes": "¿Desea cancelar el pedido y todos los procesos vinculados a él?",
      "cancel_order": "Cancelar Pedido",
      "delete_order_with_processes": "¿Desea eliminar el pedido y todos los procesos vinculados a él?",
      "delete_order": "Eliminar Pedido",
      "disallow_cancel_order": "No es posible cancelar este pedido mientras alguno de sus procesos esté vinculado a otros pedidos. Para esto, cancele/borre los procesos manualmente.",
      "disallow_delete_order": "No es posible eliminar este pedido mientras alguno de sus procesos esté vinculado a otros pedidos. Para esto, elimine los procesos manualmente.",
      "disallow_finish_order": "Esta solicitud no se puede finalizar mientras alguno de sus procesos esté abierto. Para ello, finalice los procesos manualmente.",
      "enter_the_reference_code": "Ingrese el Código de Referencia del pedido para continuar.",
      "finish_order": "Finalizar Pedido",
      "reference_code": "Código de referencia",
      "unfinish_order": "Reabrir Pedido"
    },
    "cancel": "¡Pedido cancelado con éxito!",
    "delete": "Pedido eliminado con éxito!",
    "extra_subform": "Campos adicionales",
    "finish_order_confirmation_description": "¿Desea finalizar el Pedido?",
    "unfinish_order_confirmation_description": "¿Desea reabrir el Pedido?",
    "finish_order_confirmation_title": "Finalización de Pedido",
    "unfinish_order_confirmation_title": "Reapertura de Pedido",
    "finish_order_error": "No fue posible finalizar el Pedido.",
    "finish_order_success": "¡Pedido finalizado con éxito!",
    "unfinish_order_success": "¡Pedido reabierto con éxito!",
    "save": "Guardar alteraciones",
    "success": "¡Cambios guardados con éxito!",
    "tabs": { "order_data": "Datos del Pedido", "pdf_documents": "Documentos PDF", "processes": "Procesos" }
  },
  "pdf_documents": { "no_content": "No hay documentos PDF configurados para esa operación." },
  "process": {
    "checkpoints_processes": {
      "processes": "Procesos: {{total}} | Abiertos: {{opened}} | Cerrados: {{finished}}",
      "waiting": "Esperando Proceso"
    }
  },
  "process_components": {
    "booking_quotation": {
      "title": "Cotización de booking",
      "not_started": "No iniciada",
      "freight_agents": "Agentes de carga",
      "no_agents": "Ningún agente de carga en el grupo de notificación de la página de cotización",
      "documents": "Documentos del proceso a enviar",
      "search_document": "Buscar documento del proceso",
      "documents_selected": "{{selected}} de {{total}} seleccionados",
      "closes_at": "Fecha y hora de cierre ({{timezone}})",
      "documents_hint": "Disponibles en el enlace de cada agente",
      "period_preview": "Duración prevista",
      "send": "Enviar la cotización",
      "sent": "Cotización enviada a los agentes",
      "save_before_send": "Guarde los cambios antes de enviar la cotización",
      "view_draft": "Ver borrador",
      "review": "Revisar",
      "preview_title": "Borrador de la cotización",
      "confirm_send_title": "Confirmar envío de la cotización",
      "opened_at": "Abierta el {{date}} ({{timezone}})",
      "cancellation_reason": "Motivo de la cancelación: {{reason}}",
      "cancel": "Cancelar cotización",
      "cancel_confirm_description": "La cotización {{reference}} se cerrará sin ganador. Las propuestas recibidas quedan archivadas y los enlaces dejan de aceptar envíos.",
      "cancel_reason_label": "Motivo (opcional)",
      "cancel_reason_placeholder": "Ej.: embarque aplazado por el cliente",
      "cancel_notified": "Serán avisados por correo electrónico",
      "canceled": "Cotización cancelada",
      "sealed": {
        "title": "Propuestas en reserva hasta el cierre",
        "description": "Ningún valor es visible antes del fin del período. Todas las propuestas se abren al mismo tiempo."
      },
      "closes_at_short": "cierra {{date}} ({{timezone}})",
      "responded_count": "<strong>{{responded}}</strong> de {{invited}} respondieron",
      "values_hidden": "valores ocultos",
      "last_updated_at": "Actualizada {{date}}",
      "decline_reason": "Motivo: {{reason}}",
      "reopen": "Reabrir cotización",
      "reopen_with_new_agents": "Reabrir con nuevos agentes",
      "round": "{{round}}.ª ronda",
      "reopen_dialog": {
        "closed_at": "Cerrada {{date}}",
        "responded": "{{responded}} de {{invited}} respondieron",
        "viewed_alert": "Las propuestas de la {{round}}.ª ronda ya fueron visualizadas. Las nuevas propuestas y ediciones vuelven a ser confidenciales hasta el nuevo cierre.",
        "add_agent": "Agregar agente",
        "select_agent": "Seleccionar agente",
        "remove_agent": "Quitar agente",
        "new": "Nuevo",
        "locked": "{{status}} · no se puede quitar",
        "proposals_title": "Propuestas de la {{round}}.ª ronda",
        "keep": {
          "title": "Mantener propuestas",
          "description": "Quien respondió puede editar la propuesta hasta el nuevo plazo. Quien no respondió tiene una nueva oportunidad.",
          "notifies": "Notifica: plazo extendido"
        },
        "restart": {
          "title": "Reiniciar desde cero",
          "description_one": "La {{count}} propuesta recibida ({{agents}}) será descartada. Todos los agentes envían nuevamente.",
          "description_other": "Las {{count}} propuestas recibidas ({{agents}}) serán descartadas. Todos los agentes envían nuevamente.",
          "notifies": "Notifica: revisión solicitada"
        },
        "agents_count_one": "{{count}} agente",
        "agents_count_other": "{{count}} agentes",
        "closes_at": "Nueva fecha-hora de cierre ({{timezone}})",
        "notified_keep_one": "{{count}} agente será notificado — nuevo plazo: {{extended}} · nueva invitación: {{invites}}",
        "notified_keep_other": "{{count}} agentes serán notificados — nuevo plazo: {{extended}} · nueva invitación: {{invites}}",
        "notified_restart_one": "{{count}} agente será notificado — revisión solicitada: {{revision}} · nueva invitación: {{invites}}",
        "notified_restart_other": "{{count}} agentes serán notificados — revisión solicitada: {{revision}} · nueva invitación: {{invites}}",
        "success": "Cotización reabierta"
      },
      "closed_at": "Cerrada el {{date}} ({{timezone}}) · {{responded}} de {{invited}} respondieron",
      "compare": {
        "button": "Comparar propuestas",
        "title": "Comparar propuestas",
        "responded": "{{responded}} de {{invited}} respondieron",
        "proposals_count_one": "{{count}} propuesta",
        "proposals_count_other": "{{count}} propuestas",
        "closed_at": "cerrada {{date}}",
        "export": "Exportar Excel",
        "export_error": "No fue posible exportar el comparativo",
        "sections": {
          "conditions": "Condiciones",
          "origin": "Origen",
          "international": "Internacional",
          "destination": "Destino"
        },
        "labels": { "transit_time": "Transit time", "representativeness": "% representatividad" },
        "transit_days_one": "{{count}} día",
        "transit_days_other": "{{count}} días",
        "proposal_label": "Propuesta {{index}}",
        "sent_at": "Enviada {{date}}",
        "edited_at": "Editada {{date}}",
        "lowest_cost": "Menor costo",
        "representativeness_tooltip": "Porcentaje del costo total de la propuesta sobre el valor final de las Invoices — base de {{value}}.",
        "attachments": "Adjuntos",
        "attachments_count_one": "{{count}} adjunto",
        "attachments_count_other": "{{count}} adjuntos",
        "name_winner": "Nombrar ganador",
        "file_name": "comparativo_propuestas",
        "footer_hint": "Haga clic en un agente para abrir el detalle de la propuesta y los adjuntos.",
        "close": "Cerrar",
        "empty": "Ninguna propuesta enviada",
        "proposal": "Propuesta",
        "total": "Total",
        "view_details": "Ver detalles",
        "list_footer": "El comparativo completo y los adjuntos de cada propuesta se abren en una pantalla dedicada."
      },
      "proposal_drawer": {
        "proposal": "Propuesta · {{number}}",
        "sent_at": "Enviada el",
        "edited_at": "Editada el",
        "summary": "Resumen",
        "goods_value_percent": "% del valor de la mercancía",
        "route": "Carga → Descarga",
        "values": "Valores",
        "total": "Total de la propuesta",
        "total_hint": "Suma de los seis factores informados por el agente"
      },
      "snapshot_changes": {
        "title": "Datos del proceso modificados después del envío",
        "description": "Los agentes invitados cotizaron con los valores anteriores y pueden necesitar revisar sus propuestas."
      },
      "name_winner": {
        "title": "Nombrar ganador",
        "description": "¿Nombrar a <strong>{{agent}}</strong> como ganadora de la cotización {{reference}}? Esta acción es irreversible.",
        "total": "Total de la propuesta",
        "sealine_route": "Naviera · Puertos",
        "collection_notes": "Observaciones para la recolección (opcional)",
        "collection_notes_placeholder": "Ej.: lugar, horario y contacto para la recolección",
        "on_confirm": "Al confirmar",
        "confirmation_email": "Correo de <strong>confirmación</strong> enviado a la ganadora",
        "thanks_email": "Correo de <strong>agradecimiento</strong> enviado a los demás participantes",
        "confirm": "Nombrar ganador",
        "success": "Ganador nombrado"
      },
      "winner": {
        "banner": "{{agent}} fue nombrada ganadora",
        "badge": "Propuesta ganadora",
        "route": "Carga → Descarga",
        "awaiting_booking": "Esperando datos del booking",
        "link_sent_at": "Enlace enviado el {{date}}",
        "booking_received": "Datos del booking recibidos",
        "received_at": "Enviado el {{date}}",
        "resend_link": "Reenviar enlace de booking",
        "resend_success": "Enlace de booking reenviado",
        "automations": "Automatizaciones disparadas",
        "confirmation_sent": "Correo de <strong>confirmación</strong> enviado a {{agents}}",
        "thanks_sent": "Correo de <strong>agradecimiento</strong> enviado a {{agents}}"
      }
    },
    "demurrage": {
      "sections": { "container": "Container", "demurrage": "Demurrage", "payments": "Pagos", "status": "Status" }
    },
    "deadlines": {
      "title": "Programación de Navios",
      "subtitle": "Exportación",
      "dates": {
        "draft": { "title": "Deadline DRAFT", "subtitle": "Shipping Instructions" },
        "vgm": { "title": "Deadline VGM", "subtitle": "Verified Gross Mass" },
        "gate": { "title": "GATE", "subtitle": "Apertura Gate" },
        "cargo": { "title": "Deadline CARGA", "subtitle": "Carga" }
      },
      "reference_popper": {
        "title": "Cambiar Referencia",
        "description": "Nota: El modo auto selecciona automáticamente la fecha más restrictiva entre las disponibles.",
        "select": "Seleccionar"
      },
      "table": { "last_search": "Última consulta" },
      "alert_status": {
        "not_found": "Datos no encontrados para ese Navio y Viagem",
        "pending": "Esperando datos",
        "invalid": "Datos inválidos",
        "sealine_not_supported": "Aún no contamos con integración con este Armador para la Programación de Buques"
      }
    }
  },
  "process_modal": {
    "actions_menu": {
      "cancel_process": "Cancelar Proceso",
      "delete_process": "Eliminar Proceso",
      "enter_the_reference_code": "Ingrese el Código de Referencia del pedido para continuar.",
      "finish_process": "Finalizar Proceso",
      "unfinish_process": "Reabrir Proceso"
    },
    "cancel": "¡Proceso cancelado con éxito!",
    "cargo_information": { "fields": { "cargo_type": "Tipo de carga" }, "title": "Información de la carga" },
    "insights": { "tab": "Insights" },
    "costs": {
      "tab": "Costs",
      "deviation": "Desviación",
      "planned": "Planificado",
      "realized": "Realizado",
      "average": "Media",
      "per_reference": {
        "informations": { "expenses": "Despesas" },
        "titles": {
          "BRAZILIAN_INVOICE_VALUE": "Valor del Factura (BR)",
          "CALCULATED_CUBAGE_CUBIC_METERS": "Volumen Calculado",
          "CALCULATED_GROSS_WEIGHT_KG": "Peso Bruto Calculado",
          "GROSS_WEIGHT_KG": "Peso Bruto",
          "QUANTITY": "Cantidad"
        }
      },
      "tabs": { "product": "Producto", "shipment": "Embarque", "per_reference": "Cálculos de unidades" },
      "update": { "success": "Costo guardado con éxito" },
      "toolbar": {
        "export": "Exportar",
        "export_error": "Error al exportar costos. Por favor, intente nuevamente más tarde.",
        "export_loading": "Exportando...",
        "expand": "Expandir",
        "filter_items": "Filtrar Productos",
        "collapse": "Recoger",
        "close_cost": "Cerrar Costo",
        "reopen_cost": "Reabrir Custo",
        "export_columns": {
          "cost": "Costo",
          "deviation": "Desviación",
          "group": "Grupo",
          "planned_cost": "Planificación",
          "precification_model": "Modelo de Precificacion",
          "product": "Producto",
          "realized": "Realizado",
          "reference_product_prorated": "Referência de Prorrateo",
          "reference_value": "Valor de Referencia",
          "reference": "Referencia",
          "sub_group": "Subgrupo",
          "total_deviation": "Total Desviación",
          "total_planned_cost": "Total Planificación",
          "total_realized": "Total Realizado",
          "uniqueness": "Unicidad",
          "unitary_deviation": "Valor Unitario Desviación",
          "unitary_planned_cost": "Valor Unitario Planificación",
          "unitary_realized": "Valor Unitario Realizado"
        }
      },
      "totals": { "title": "TOTAL", "reference": "Embarque" }
    },
    "delete": "Proceso eliminado con éxito!",
    "finish_process_confirmation_description": "¿Desea finalizar el proceso?",
    "unfinish_process_confirmation_description": "¿Desea desfinalizar el proceso?",
    "finish_process_confirmation_title": "Finalización de Proceso",
    "ufinish_process_confirmation_title": "Reapertura de Proceso",
    "finish_process_error": "No fue posible finalizar el Proceso.",
    "unfinish_process_error": "No fue posible reabrir el Proceso.",
    "finish_process_success": "¡Proceso finalizado con éxito!",
    "unfinish_process_success": "¡Proceso reabierto con éxito!",
    "history": {
      "changes": { "types": { "insert": "Creación", "delete": "Eliminación", "update": "Actualización" } },
      "no_content_message": "No hay cambios en este proceso",
      "title": "Historial de cambios"
    },
    "lead_time": {
      "conclusion_date": "Fecha de finalización",
      "no_content": "No hay Lead Time vinculado",
      "error_content": "Error al calcular los lead times previstos, verifique las fechas insertadas.",
      "preview_conclusion_date": "Fecha de finalización prevista",
      "status": { "ADVANCED": "Adelantado {{time}}", "LATE": "Retrasado {{time}}", "ON_TIME": "On Time" },
      "timeline": {
        "titles": { "deviance": "Desviación", "planned": "Planificación", "realized": "Realizado/Previsto" },
        "today": "Hoy"
      },
      "errors": {
        "realized": "Realizado",
        "estimated": "Previsto",
        "planned": "Planificado",
        "dates": "Fechas",
        "lead_time": "Lead Time"
      },
      "update": { "success": "Lead times guardado con éxito" }
    },
    "process_not_found": "Proceso no encontrado.",
    "process_unauthorized": "No tiene permiso para acceder a este proceso.",
    "reset_changes_btn": "Descartar Cambios",
    "reset_changes_confirmation_description": "Los cambios no guardados se descartarán. ¿Desea continuar?",
    "reset_changes_confirmation_title": "Descartar Cambios",
    "restored": "¡Elemento restaurado con éxito!",
    "save": "Guardar alteraciones",
    "success": "¡Cambios guardados con éxito!"
  },
  "products": {
    "edit_products": {
      "page_title": "Editar Producto",
      "save": "Guardar",
      "success": "Producto modificado con éxito",
      "title": "Editar Producto"
    },
    "product_drawer": { "title": "Detalhes del Producto" },
    "products_form": {
      "package_levels": "Niveles de Embalaje",
      "package": "Embalaje y Logística",
      "primary_package": "Embalaje Primario",
      "product_characteristics": "Características del Producto",
      "product_data": "Datos del Producto",
      "success": "Producto añadido con éxito",
      "popover_info": {
        "title": "Información",
        "package_data": {
          "conclusion": "Estos niveles ayudan a representar mejor el producto en la cadena logística y facilitan la planificación, el transporte y el cálculo de costos.",
          "example_title": "Puedes detallar con más niveles de embalaje opcionales:",
          "info": "El Embalaje Primario es la unidad base de registro, utilizada como referencia para la cantidad del producto al crear los procesos.",
          "examples": {
            "containerization": "Containerización (ej.: pallets en el contenedor)",
            "content": "Contenido (ej.: botella)",
            "multiple": "Unitización (ej.: cajas dentro de una caja más grande)",
            "palletization": "Paletización (ej.: cajas sobre un pallet)"
          }
        }
      }
    },
    "products_list": {
      "add_new": "Agregar Producto",
      "archive_confirm_description": "El producto se archivará y se eliminará de la lista activa. ¿Desea continuar?",
      "archive_confirm_title": "¿Archivar producto?",
      "page_title": "Productos",
      "product_archived": "¡Producto archivado con éxito!",
      "title": "Productos"
    },
    "products_new": { "page_title": "Registrar Producto", "title": "Registrar Producto" }
  },
  "report_columns": {
    "shared": {
      "automatic": "Automático",
      "deviation_days": "Desvio",
      "manual": "Manual",
      "operation_name": "Operación",
      "reference_code": "Cod. Referencia",
      "tracking_mode": "Modo Tracking",
      "tracking_status": "Status Tracking"
    },
    "shipment_containers": "Containers Embarque",
    "realized_at": "Realizado"
  },
  "quick_filters": { "active_label": "Activos:", "clear": "Limpiar" },
  "reports": {
    "add_new": "Crear informe",
    "delete": {
      "success_message": "Relatório eliminado con éxito",
      "title": "¿Está seguro de que desea eliminar el informe {{ reportName }}?"
    },
    "edit_report_modal": { "success": "Informe modificado con éxito", "title": "Editar informe" },
    "new_report_modal": { "success": "Informe creado con éxito", "title": "Crear nuevo informe" },
    "refresh": "Actualizar",
    "report_changes": {
      "save": "Salvar Informe",
      "success": "Ha realizado cambios en la visualización del informe que no fueron guardados, ¿desea guardar y actualizar el informe?",
      "title": "Este informe posee alteraciones que aún no fueron guardadas.",
      "revert": "Revertir cambios"
    },
    "report_modal": { "name_field": "Nombre de informe" },
    "select_report": "Informe",
    "table": { "no_content": "Ningún informe para mostrar" },
    "export": {
      "success_message": "El informe está siendo procesado en segundo plano. Puede navegar en otras páginas mientras tanto"
    },
    "duplicate_report_modal": {
      "title": "Duplicar informe",
      "success": "Informe duplicado correctamente",
      "unsaved_changes_tooltip": "Hay cambios sin guardar"
    }
  },
  "routes": {
    "edit_route": { "page_title": "Editar Ruta" },
    "new_route": {
      "actions": {
        "add_event": "Agregar evento",
        "add_local": "Agregar ubicación",
        "add_route": "Agregar ruta",
        "edit_local": "Editar ubicación",
        "remove_event": "Eliminar evento",
        "remove_local": "Eliminar ubicación"
      },
      "page_title": "Nueva Ruta"
    },
    "route_form": {
      "add_local": "Añadir ubicaciones a los eventos para ver el mapa",
      "road_transport": "Transporte Terrestre",
      "route_data": "Datos de la Ruta",
      "successfully_created": "¡Ruta creada con éxito!",
      "successfully_updated": "{{routeName}} actualizada com éxito!"
    },
    "routes_list": {
      "page_title": "Rutas",
      "route_deleted_successfully": "Ruta eliminada con éxito!",
      "table": { "active": "Activo", "inactive": "Inactivo", "status": "Estado" }
    }
  },
  "search": { "location_placeholder": "Buscar dirección", "placeholder": "Buscar" },
  "select_workspace": {
    "loading": "Cargando espacios de trabajo",
    "title": "Seleccione su espacio de trabajo",
    "search": "Buscar"
  },
  "settings": {
    "credentials": {
      "credential_modal": {
        "create_success": "¡Credencial creada con éxito!",
        "delete_success": "¡Credencial eliminada con éxito!",
        "edit_credential": "Editar Credencial",
        "expired_at": "Expirado en:",
        "expires_at": "Válido hasta:",
        "new_credential": "Nueva Credencial",
        "password": "Contraseña",
        "update_file": "Actualizar Archivo",
        "update_success": "¡Credencial actualizada con éxito!",
        "username": "Nombre de usuario"
      },
      "credential_types": "Tipo de Credenciales",
      "no_credentials": "No hay crendeciales para mostrar",
      "search": "Búsqueda",
      "title": "Credenciales"
    },
    "general_data": {
      "card_size_description": "Con esta opción, las tarjetas son más pequeñas y ocupan menos espacio vertical en pantalla.",
      "date_format": "Formato de fecha",
      "language_and_regional_settings": "Idioma y Configuraciones regionales",
      "success": "¡Datos generales actualizados con éxito!",
      "time_format": "Formato de hora"
    },
    "notification_groups": {
      "add_recipient_success": "¡Destinatario agregado con éxito!",
      "create_success": "¡Grupo de notificación creado con éxito!",
      "delete_recipient_success": "¡Destinatario eliminado con éxito!",
      "update_recipient_success": "¡Destinatario actualizado con éxito!",
      "recipient_modal": {
        "add_recipient": "Agregar destinatario",
        "edit_recipient": "Editar destinatario",
        "title": "Gestionar destinatarios",
        "language": "Idioma",
        "manage_recipients": "Gestionar destinatarios",
        "no_recipients": "Sin destinatarios para este rol",
        "no_roles": "Sin roles configurados en este grupo",
        "partnership": "Socio"
      },
      "delete_success": "¡Grupo de notificación eliminado con éxito!",
      "form": {
        "create_button": "Crear grupo",
        "create_title": "Nuevo grupo de notificación",
        "edit_button": "Guardar cambios",
        "edit_title": "Editar grupo de notificación"
      },
      "new_group": "Nuevo Grupo",
      "title": "Grupos de Notificación",
      "update_success": "¡Grupo de notificación actualizado con éxito!"
    },
    "tabs": {
      "credentials": "Credenciales",
      "general_data": "Datos Generales",
      "notification_groups": "Grupos de Notificación",
      "users": "Usuarios",
      "workspace": "Workspace"
    },
    "title": "Configuraciones",
    "users": {
      "create_success": "Usuario creado con éxito!",
      "delete_success": "Usuario excluído con éxito!",
      "edit": { "button_confirm": "Editar Usuario", "title": "Editar Usuario" },
      "export": { "filename": "ListaUsuario" },
      "new": { "button_confirm": "Crear usuario", "title": "Nuevo Usuario" },
      "table": { "last_login_without_data": "Sin acesso previo" },
      "update_success": "Usuário actualizado con éxito!",
      "search_field_error": "La búsqueda debe contener {{minLength}} o más caracteres"
    },
    "workspace": {
      "document_type_label": { "default": "Documento Oficial" },
      "image_upload": { "caption": "Extensiones: PNG, JPG, y SVG", "update": "Editar Logo", "upload": "Agregar Logo" },
      "success": "¡Datos del espacio de trabajo actualizados con éxito!"
    }
  },
  "sidebar": {
    "actors": "Intervenientes",
    "agents_executions": "Ejecuciones",
    "agents": "Agentes",
    "booking_quotations": "Cotizaciones",
    "docs": "Documentación de la API",
    "documents": "Documentos",
    "drivers": "Conductores",
    "insights": "Insights",
    "integration_logs": "Logs de Integración",
    "integrations": "Integración",
    "lpcos": "LPCOs",
    "maritime_transport": "Transporte Marítimo",
    "mercante": "Mercante",
    "new_agent": "Nuevo Agente",
    "operations": "Operaciones",
    "port_terminals": "Terminales Portuários",
    "products": "Productos",
    "road_transport": "Transporte Rodoviário",
    "routes": "Rutas",
    "settings": "Configuarciones",
    "sign_out": "Cerrar sesión",
    "support": "Apoyo",
    "switch_workspace": "Cambiar espacio de trabajo",
    "tracking": "Tracking",
    "trailers": "Remolques",
    "vehicles": "Vehículos"
  },
  "siscomex_product": {
    "drawer": {
      "attributes_section": "Atributos preenchidos",
      "created_at": "Creado en",
      "not_synced": "Producto aún no sincronizado con el Catálogo del Siscomex.",
      "summary_section": "Resumen",
      "title": "Siscomex · Catálogo de Productos"
    }
  },
  "siscomex_sync": {
    "rows": {
      "connector": "Conector",
      "entity": "Entidad",
      "in_progress": "en curso",
      "inserted_at": "Insertado en",
      "last_sync": "Última sincronización"
    },
    "rate_limited": "Solo se puede forzar la sincronización cada 60 segundos. Intente nuevamente en breve.",
    "sync_now": "Sincronizar ahora",
    "syncing_title": "Sincronizando"
  },
  "subscription_update_snackbar": {
    "order": {
      "description": "¿Desea actualizar el pedido con las modificaciones más recientes? Sus cambios pueden ser sobrescritos por la actualización.",
      "title": "Hubo cambios en el pedido",
      "update_button": "Actualizar Pedido",
      "updated_message": "Hubo cambios en el pedido y el pedido fue actualizado automáticamente."
    },
    "process": {
      "description": "¿Desea actualizar el proceso con las modificaciones más recientes? Sus cambios pueden ser sobrescritos por la actualización.",
      "title": "Hubo cambios en el proceso",
      "update_button": "Actualizar Proceso",
      "updated_message": "Hubo cambios en el proceso y el proceso fue actualizado automáticamente."
    }
  },
  "trailers": {
    "edit_trailer": { "page_title": "Editar Remolque", "success": "Remolque editado con éxito" },
    "new_trailer": {
      "form_fields": { "without_tracker": "No tiene rastreador" },
      "page_title": "Cadastrar Remolque",
      "success": "Remolque adicionado con éxito"
    },
    "trailers_list": {
      "add_new_trailer": "Agregar Remolque",
      "page_title": "Remolques",
      "table": { "tracking": "Rastreador" },
      "trailer_deleted": "Remolque excluído con suceso!"
    }
  },
  "trip": {
    "containers": "Transporte de Contenedores",
    "tracking": {
      "client_arrival_at": "Llegada al cliente",
      "client_departure_at": "Salida del cliente",
      "end_at": "Fin del Viaje",
      "invoice_exchange_end_at": "Salida del Cambio de NF",
      "invoice_exchange_start_at": "Llegada reemplazo de NF",
      "start_at": "Inicio de Viaje",
      "title": "Tracking"
    }
  },
  "unsaved_dialog": {
    "description": "¿Está seguro de que desea descartar estos cambios?",
    "title": "Cambios no guardados"
  },
  "upload_file_order": {
    "addNew": "Descarga de archivo(s)",
    "btnSalvar": "Guardar",
    "buttonUpload": "Agregar nuevo archivo",
    "selectFiles": "Seleccione el tipo de archivo",
    "success": "Archivo eliminado con éxito"
  },
  "vehicles": {
    "edit_vehicle": { "page_title": "Editar Vehículos", "success": "Vehículos editado con éxito" },
    "new_vehicle": {
      "form_fields": { "without_tracker": "No tiene rastreador" },
      "page_title": "Registrar Vehículos",
      "success": "Vehículos agregado con éxito"
    },
    "vehicles_list": {
      "add_new_vehicle": "Agregar vehículos",
      "change_vehicle": "Cambiar vehículos",
      "page_title": "Vehículos",
      "table": { "tracking": "Rastreador" },
      "vehicle_deleted": "Vehículo eliminado con éxito!"
    }
  },
  "vessels": { "country": "País de la Embarcación" },
  "warnings": {
    "after_deleting_temporary": "Después de ser eliminado, podrás recuperarlo haciendo clic en descartar cambios antes de guardar. ¿Deseas continuar?",
    "after_deleting_this_information": "Una vez eliminada, esta información no podrá ser recuperada. ¿Deseas continuar?",
    "are_you_sure": "¿Está seguro?",
    "empty_general_list_message": "No hay información aquí todavía",
    "not_informed": "-",
    "process_empty_data_list_message": "Este proceso aún no tiene datos registrados.",
    "there_is_already_a_record_registered_with_this_number": "Ya existe un registro con este número",
    "this_action_can_not_be_undone": "Esta acción no se puede deshacer. ¿Desea continuar?",
    "this_item_can_not_be_deleted": "No es posible eliminar este ítem!",
    "this_will_be_automatically_fulfilled": "Este campo se completará automáticamente cuando se cree el pedido.",
    "to_delete_item": "Eliminar {{text}} ?",
    "without_data_to_export": "No hay datos para exportar"
  },
  "yup": {
    "at_least_one": "Este campo debe tener al menos 1 elemento.",
    "cannot_be_equal_to": "Este campo debe ser diferente del campo {{otherField}}",
    "mixed_invalid_field": "Campo no válido.",
    "mixed_required_field": "Este campo es obligatorio",
    "number_max": "Este campo debe ser menor que {{max}}.",
    "number_min": "Este campo debe ser mayor que {{min}}.",
    "required_field": "El campo {{ fieldName }} es obligatorio.",
    "string_email": "Este campo debe tener un correo electrónico válido.",
    "string_https_url": "La URL debe utilizar el protocolo HTTPS.",
    "string_max": "Este campo debe tener menos de ${max} caracteres.",
    "string_min": "Este campo debe tener más de ${min} caracteres."
  }
}
